import styled from "styled-components";

export const InfoPanelWrapper = styled.div`
  /* Inline forms — no top margin, sits flush in the pill row. */
  .inline-form {
    margin-top: 0;
  }

  .inline-pill {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    padding: 8px 12px;
    background-color: var(--bg-color-secondary, #ffffff);
    border: 1px solid var(--border-color, #e8e8e8);
    border-radius: 8px;
  }
  .inline-pill-alias-input {
    flex: 1 1 100%;
  }
  .inline-pill-alias-input .inline-alias {
    border: 1px solid var(--border-color-secondary, #eaeaea);
    background: var(--bg-color-secondary, #fafafa);
    border-radius: 6px;
    height: 28px;
    font-size: 13px;
  }
  .inline-pill-desc {
    flex: 1 1 100%;
    margin-top: 4px;
  }
  .inline-pill-desc textarea {
    border-radius: 6px;
    font-size: 13px;
  }

  /* Normalize placeholder color across the alias input and the description
     textarea so they read as one cohesive form. */
  .inline-pill input::placeholder,
  .inline-pill textarea::placeholder {
    color: var(--text-color-muted, rgba(0, 0, 0, 0.4));
    opacity: 1;
  }
`;
